module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "accordian",
    on: {
      "click": setActive
    }
  }, [_t("default")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d0d32bb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accordian.vue
// module id = 66
// module chunks = 2